
import ContentLayout from '@/pages/content/components/ContentLayout.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import { LegalNoticeQuery } from '~/graphql/queries/Cms';
export default {
  layout: 'MainLayout',
  name: 'CgvPage',
  auth: false,
  apollo: {
    legalNoticePage: {
      query: LegalNoticeQuery,
      variables() {
        return {
          lang: this.$i18n.locale,
        };
      },
    },
  },
  computed: {
    breadcrumbLinks() {
      const links = [
        {
          link: '/',
          text: this.$t('Home'),
        },
        {
          text: this.$t('Legal notice'),
        },
      ];
      return links;
    },
  },
  mounted() {
    if (process.client) {
      window.scrollTo(0, 0);
    }
  },
  components: { ContentLayout, Breadcrumb },
};
